import { render } from "./FormatAlignRight.vue?vue&type=template&id=f58be82c"
import script from "./FormatAlignRight.vue?vue&type=script&lang=js"
export * from "./FormatAlignRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatAlignRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f58be82c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f58be82c', __exports__)) {
    api.reload('f58be82c', __exports__)
  }
  
  module.hot.accept("./FormatAlignRight.vue?vue&type=template&id=f58be82c", () => {
    api.rerender('f58be82c', render)
  })

}


export default __exports__